import React from "react";
import fetch from "unfetch";
import {
  notification,
  Modal,
  List,
  Divider,
  Icon,
  Button,
  Checkbox,
  Table,
  Select,
  Badge,
  Input,
  DatePicker,
  Alert,
  Spin,
  Tooltip,
} from "antd";
import moment from "moment";
import axios from "axios";

const Column = Table.Column;
const Option = Select.Option;
const OptGroup = Select.OptGroup;
const Search = Input.Search;

export default class extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showForm: false,
      data: props.data,
      users: [],
      filterUsers: [],
      groups: [],
      invoiceNumber: 1,
      invoiceDate: moment(),
      invoiceDescription: "",
      invoiceDetails: [{}],
      invoiceLines: 1,
      invoiceMessage:
        "Cher membre,\n\nVous trouverez ci-joint votre dernière facture Le Hub Bezannes",
      loading: true,
      sendPdf: false,
    };
    this.handleOk = this.handleOk.bind(this);
  }

  componentDidMount() {
    fetch("/api/invoice", {
      credentials: "include",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": localStorage.getItem("x-access-token"),
      },
    })
      .then((res) => res.json())
      .then((invoices) => {
        fetch("/api/user", {
          credentials: "include",
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": localStorage.getItem("x-access-token"),
          },
        })
          .then((res) => res.json())
          .then((data) => {
            this.setState({
              users: data.users,
              filterUsers: data.users,
              groups: data.groups,
              data: invoices,
              filterData: invoices,
              invoiceNumber:
                (invoices.length > 0 &&
                  parseInt(
                    invoices.sort((a, b) => b.identifier - a.identifier)[0]
                      .identifier
                  ) + 1) ||
                1,
              invoiceDescription: "Facture ponctuelle",
              loading: false,
            });
          });
      });
  }

  handleFilter(val, option) {
    return option.props.filter.toLowerCase().indexOf(val.toLowerCase()) >= 0;
  }

  handleChange = (e, idx) => {
    let tmp = this.state.invoiceDetails;
    tmp[idx][e.target.name] = e.target.value;
    this.setState({
      invoiceDetails: tmp,
      previewed: false,
    });
  };

  searchData = (val) => {
    if (val.target.value.length > 2) {
      this.setState({
        data: this.state.filterData.filter(
          (f) =>
            `${String(f.identifier)}, ${f.company.name}, ${f.description}`
              .toLowerCase()
              .indexOf(val.target.value) !== -1
        ),
      });
    }
  };

  modal(record) {
    let users = this.state.users.filter(
      (f) => f.email && f.company && f.company._id === record.companyId
    );

    this.setState({
      modalVisible: true,
      emailTitle: "Facture",
      emailMessage:
        "Cher membre,\n\nVous trouverez ci-joint votre dernière facture Le Hub Bezannes",
      destinataire: users[0].email || "",
      pdfIdentifier: record.identifier,
    });
  }

  handleOk() {
    if (
      !this.state.destinataire ||
      !this.state.emailTitle ||
      !this.state.emailMessage
    ) {
      notification.error({
        message: "Erreur",
        description: "Des informations sont manquantes",
      });
    } else {
      this.setState({ emailLoading: true });
      fetch("/api/invoice/email", {
        method: "POST",
        credentials: "include",
        headers: {
          "x-access-token": localStorage.getItem("x-access-token"),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          emailTitle: this.state.emailTitle,
          emailMessage: this.state.emailMessage,
          destinataire: this.state.destinataire,
          pdfIdentifier: this.state.pdfIdentifier,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.success) {
            notification.success({
              message: "Envoi effectué",
              description: "L'envoi de la facture a été effectué avec succès",
            });
          } else {
            notification.error({
              message: "Erreur",
              description:
                "Une erreur est survenue, merci de réessayer dans quelques instants",
            });
          }
          this.setState({
            modalVisible: false,
            emailLoading: false,
          });
        });
    }
  }

  defaultUrl() {
    let url = window.location.origin + "/facture";
    url +=
      "?items=" +
      this.state.invoiceDetails.map((f) => `${f.objet}|${f.montant}`).join(",");
    url += `&id=${this.state.invoiceNumber}`;
    url += `&date=${this.state.invoiceDate.format("YYYYMMDD")}`;
    url += `&key=p4gh34n9`;
    return url;
  }

  viewPdf() {
    notification.warning({
      message: "Conversion PDF désactivée",
      description: "Le convertisseur Athena est désactivé temporairement.",
    });
    this.setState({
      previewed: true,
    });
  }

  downloadPdf(record) {
    fetch(`/api/invoice/${record.identifier}/download`, {
      credentials: "include",
      headers: {
        "x-access-token": localStorage.getItem("x-access-token"),
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("La facture demandée est introuvable.");
        }
        const disposition = response.headers.get("content-disposition") || "";
        const match = disposition.match(/filename="?([^";]+)"?/);
        return response.blob().then((pdf) => ({
          pdf,
          filename: match ? match[1] : `Facture-${record.identifier}.pdf`,
        }));
      })
      .then(({ pdf, filename }) => {
        const url = window.URL.createObjectURL(pdf);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        notification.error({
          message: "Téléchargement impossible",
          description: err.message,
        });
      });
  }

  sendPdf() {
    fetch("/api/invoice", {
      method: "POST",
      credentials: "include",
      headers: {
        "x-access-token": localStorage.getItem("x-access-token"),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        params: {
          id: this.state.invoiceNumber,
          items: this.state.invoiceDetails,
          date: this.state.invoiceDate.format("YYYY-MM-DD"),
          description: this.state.invoiceDescription,
          message: this.state.invoiceMessage,
          sendPdf: this.state.sendPdf,
        },
        recipients: this.state.recipients,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (!res.success) {
          throw new Error(res.message || "La génération des factures a échoué.");
        }
        this.setState({
          send: true,
          success: res.success,
        });
        fetch("/api/invoice", {
          credentials: "include",
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": localStorage.getItem("x-access-token"),
          },
        })
          .then((res) => res.json())
          .then((invoices) => {
            this.setState({
              filterData: invoices,
              data: invoices,
              invoiceNumber:
                (invoices.length > 0 &&
                  parseInt(
                    invoices.sort((a, b) => b.identifier - a.identifier)[0]
                      .identifier
                  ) + 1) ||
                1,
            });
          });
      })
      .catch((error) => {
        notification.error({
          message: "Génération impossible",
          description: error.message,
        });
        this.setState({ send: true, success: false });
      });
  }

  render() {
    const total = this.state.invoiceDetails.reduce(
      (prev, curr) => prev + parseFloat(curr.montant || 0),
      0
    );
    return (
      <React.Fragment>
        <h5>Facturation</h5>
        <p>Historique et edition de facture</p>
        <Divider />
        {this.state.showForm ? (
          <Button
            onClick={() => this.setState({ showForm: !this.state.showForm })}
            type="primary"
          >
            {this.state.showForm ? "Voir l'historique" : "Éditer une facture"}
          </Button>
        ) : null}
        {this.state.loading ? (
          <div
            style={{
              height: "500px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Spin size="large" />
          </div>
        ) : this.state.showForm ? (
          <div
            className="facturation-form"
            style={{ marginTop: 20, padding: 25, border: "1px #d8d8d8 solid" }}
          >
            <h4>Éditer une nouvelle facture</h4>
            <div className="form-group">
              <div>
                <div
                  style={{ marginTop: "10px", marginBottom: "5px" }}
                  className="custom-input"
                >
                  <span className="required">*</span>
                  N° facture
                  <div style={{ color: "#a8a8a8", fontSize: "12px" }}>
                    Incrémentation automatique lorsque plusieurs factures sont
                    générées
                  </div>
                </div>
                <Input
                  disabled
                  value={this.state.invoiceNumber}
                  onChange={(e) =>
                    this.setState({ invoiceNumber: e.target.value })
                  }
                />
              </div>
              <div>
                <div
                  style={{ marginTop: "10px", marginBottom: "5px" }}
                  className="custom-input"
                >
                  <span className="required">*</span>
                  Date de facturation
                  <div style={{ color: "#a8a8a8", fontSize: "12px" }}>
                    Date figurant sur la facture
                  </div>
                </div>
                <DatePicker
                  onChange={(val) => this.setState({ invoiceDate: val })}
                  format={"DD/MM/YYYY"}
                  value={this.state.invoiceDate}
                  showToday={false}
                  placeholder={"Sélectionner une date"}
                />
              </div>
            </div>
            <div className="form-group">
              <div>
                <div
                  style={{ marginTop: "10px", marginBottom: "5px" }}
                  className="custom-input"
                >
                  <span className="required">*</span>
                  Société/Groupe
                  <div style={{ color: "#a8a8a8", fontSize: "12px" }}>
                    Pour les sociétés appartenant à plusieurs groupes, l'email
                    sera envoyé une seule fois
                  </div>
                </div>
                <Select
                  mode="tags"
                  style={{ width: "100%" }}
                  placeholder="Sélectionner un groupe ou des utilisateurs"
                  value={this.state.recipients}
                  onChange={(val) =>
                    this.setState({
                      recipients: val,
                    })
                  }
                  filter
                  optionFilterProp="filter"
                  notFoundContent={null}
                >
                  <OptGroup label="Année en cours">
                    <Option
                      filter="actif"
                      value="group-actif"
                      key={"group-actif"}
                    >
                      <b style={{ textTransform: "uppercase" }}>
                        <Badge status="success" /> Actifs
                      </b>
                    </Option>
                    <Option
                      filter="passif"
                      value="group-passif"
                      key={"group-passif"}
                    >
                      <b style={{ textTransform: "uppercase" }}>
                        <Badge status="warning" /> Passifs
                      </b>
                    </Option>
                  </OptGroup>
                  <OptGroup label="Groupes">
                    {this.state.groups
                      ? this.state.groups.map((g) => {
                          return (
                            <Option filter={g.slug} key={"group-" + g.slug}>
                              <b>
                                <Badge status="default" />
                                {g.title}
                              </b>
                            </Option>
                          );
                        })
                      : ""}
                  </OptGroup>
                  <OptGroup label="Utilisateurs">
                    {this.state.users
                      ? this.state.users
                          .filter((u) => {
                            return u.email;
                          })
                          .map((u) => {
                            return (
                              <Option
                                filter={
                                  u.company.name +
                                  " " +
                                  u.firstname +
                                  " " +
                                  u.lastname
                                }
                                key={u.email}
                              >
                                <b>
                                  {u.company
                                    ? u.company.name.trim().toUpperCase() +
                                      " - "
                                    : ""}
                                </b>{" "}
                                {u.lastname ? u.lastname.toUpperCase() : ""}{" "}
                                {u.firstname
                                  ? u.firstname.trim().charAt(0)
                                  : ""}
                                .
                              </Option>
                            );
                          })
                      : ""}
                  </OptGroup>
                </Select>
              </div>
            </div>
            <div className="form-group">
              <div>
                <div
                  style={{ marginTop: "10px", marginBottom: "5px" }}
                  className="custom-input"
                >
                  <span className="required">*</span>
                  Titre de la facture
                  <div style={{ color: "#a8a8a8", fontSize: "12px" }}>
                    Utilisé pour l'archive des factures
                  </div>
                </div>
                <Input
                  value={this.state.invoiceDescription}
                  onChange={(e) =>
                    this.setState({ invoiceDescription: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="form-group">
              <div>
                <div
                  style={{ marginTop: "10px", marginBottom: "5px" }}
                  className="custom-input"
                >
                  Envoi automatique
                </div>
                <Checkbox
                  checked={this.state.sendPdf}
                  onChange={(e) => this.setState({ sendPdf: e.target.checked })}
                >
                  Déclencher un envoi automatique à la création de la facture
                </Checkbox>
              </div>
            </div>
            {this.state.sendPdf ? (
              <div className="form-group">
                <div>
                  <div className="custom-input">
                    <span className="required">*</span>
                    Message à envoyer
                    <div style={{ color: "#a8a8a8", fontSize: "12px" }}>
                      Message à insérer dans le corp du mail
                    </div>
                  </div>
                  <Input.TextArea
                    rows={8}
                    name="message"
                    value={this.state.invoiceMessage}
                    onChange={(e) =>
                      this.setState({ invoiceMessage: e.target.value })
                    }
                  />
                </div>
              </div>
            ) : null}
            <div style={{ marginBottom: "0 !important" }}>
              <div>
                <div
                  style={{ marginTop: "10px", marginBottom: "5px" }}
                  className="custom-input"
                >
                  <span className="required">*</span>
                  Détails de la facture
                </div>
              </div>
            </div>
            {Array.from(Array(this.state.invoiceLines)).map((f, idx) => (
              <div className="form-group">
                <div>
                  <div className="custom-input">
                    <div style={{ color: "#a8a8a8", fontSize: "12px" }}>
                      Objet
                    </div>
                  </div>
                  <Input
                    name="objet"
                    value={this.state.invoiceDetails[idx].objet}
                    onChange={(e) => this.handleChange(e, idx)}
                  />
                </div>
                <div>
                  <div className="custom-input">
                    <div style={{ color: "#a8a8a8", fontSize: "12px" }}>
                      Montant
                    </div>
                  </div>
                  <Input
                    type="number"
                    name="montant"
                    value={this.state.invoiceDetails[idx].montant}
                    onChange={(e) => this.handleChange(e, idx)}
                  />
                </div>
                <div
                  style={{
                    height: 50,
                    flex: 0,
                    display: "flex",
                    alignItems: "flex-end",
                    whiteSpace: "nowrap",
                  }}
                >
                  <Button
                    disabled={idx === 0}
                    onClick={() =>
                      this.setState({
                        invoiceLines: this.state.invoiceLines - 1,
                        invoiceDetails: this.state.invoiceDetails.filter(
                          (h, hIdx) => hIdx !== idx
                        ),
                      })
                    }
                    type="danger"
                  >
                    Supprimer
                  </Button>
                  <Button
                    onClick={() =>
                      this.setState({
                        invoiceLines: this.state.invoiceLines + 1,
                        invoiceDetails: this.state.invoiceDetails.concat([{}]),
                      })
                    }
                    style={{ marginLeft: 10 }}
                    type="dashed"
                  >
                    Ajouter
                  </Button>
                </div>
              </div>
            ))}

            <div className="form-group">
              <div>
                <div className="custom-input">
                  <div style={{ color: "#a8a8a8", fontSize: "12px" }}>
                    Total
                  </div>
                </div>
                <Input
                  type="text"
                  name="montant"
                  value={total + " €"}
                  disabled
                />
              </div>
              <div></div>
              <div></div>
            </div>
            <div style={{ paddingTop: 20 }}>
              {/* <div style={{color: '#a8a8a8', fontSize: '14px', marginBottom: 5}}>
                                        Vous devez prévisualiser la facture avant de pouvoir l'envoyer.
                                    </div> */}
              {/* <Button onClick={() => this.viewPdf()} disabled={total <= 0} type="dashed" style={{marginRight: 20}}>Prévisualiser la facture</Button> */}
              <Button
                onClick={() => this.sendPdf()}
                disabled={total <= 0 || this.state.send}
                type="primary"
              >
                Enregistrer la facture
              </Button>
            </div>
            <div style={{ paddingTop: 20 }}>
              {this.state.send ? (
                this.state.success ? (
                  <Alert message="Facture(s) enregistrée(s)" type="success" />
                ) : (
                  <Alert
                    message="Une erreur est survenue, merci d'actualiser et de réessayer"
                    type="error"
                  />
                )
              ) : null}
            </div>
          </div>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Button
                onClick={() =>
                  this.setState({ showForm: !this.state.showForm })
                }
                type="primary"
              >
                {this.state.showForm
                  ? "Voir l'historique"
                  : "Éditer une facture"}
              </Button>
              <Search
                placeholder="Rechercher"
                onChange={(value) => this.searchData(value)}
                style={{ width: 200 }}
              />
            </div>
            <Table
              style={{ marginTop: 20 }}
              dataSource={this.state.data
                .sort((a, b) => a.identifier - b.identifier)
                .map((f) => ({
                  identifier: f.identifier,
                  company: f.company.name,
                  companyId: f.company._id,
                  description: f.description,
                  total: f.items.reduce(
                    (prev, curr) => prev + parseFloat(curr.montant),
                    0
                  ),
                  items: f.items,
                  address: f.company.address,
                  city: f.company.city,
                  date: f.date,
                }))}
              locale={{
                emptyText: "Aucune facture",
              }}
            >
              <Column
                width={120}
                title="N° facture"
                dataIndex="identifier"
                key="identifier"
              />
              <Column title="Société" dataIndex="company" key="company" />
              <Column
                title="Description"
                dataIndex="description"
                key="description"
              />
              <Column
                width={120}
                title="Date"
                dataIndex="date"
                key="date"
                render={(text, record) => (
                  <span>{moment(text).format("DD/MM/YYYY")}</span>
                )}
              />
              <Column
                width={120}
                title="Montant"
                dataIndex="total"
                key="total"
                render={(text, record) => <b>{text} €</b>}
              />
              <Column
                width={200}
                title="Actions"
                key="actions"
                render={(text, record) => (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Tooltip title="Envoyer la facture">
                      <Button
                        style={{ marginRight: 10 }}
                        onClick={() => this.modal(record)}
                        type="primary"
                      >
                        <Icon type="mail" />
                      </Button>
                    </Tooltip>
                    <Tooltip title="Télécharger la facture">
                      <Button
                        onClick={() => this.downloadPdf(record)}
                        type="primary"
                      >
                        <Icon type="download" />
                      </Button>
                    </Tooltip>
                  </span>
                )}
              />
            </Table>
            <Modal
              title="Envoyer la facture"
              visible={this.state.modalVisible}
              // onOk={this.handleOk}
              // onCancel={() => this.setState({modalVisible: false})}
              // okText="Envoyer"
              // cancelText="Annuler"
              onCancel={() => this.setState({ modalVisible: false })}
              maskClosable={false}
              footer={[
                <Button
                  key="back"
                  onClick={() => this.setState({ modalVisible: false })}
                >
                  Annuler
                </Button>,
                <Button
                  key="submit"
                  type="primary"
                  loading={this.state.emailLoading}
                  onClick={this.handleOk}
                >
                  Envoyer
                </Button>,
              ]}
            >
              <div className="form-group">
                <div>
                  <div
                    style={{ marginTop: "10px", marginBottom: "5px" }}
                    className="custom-input"
                  >
                    <span className="required">*</span>
                    Destinataire
                  </div>
                  <Input
                    value={this.state.destinataire}
                    onChange={(e) =>
                      this.setState({ destinataire: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="form-group">
                <div>
                  <div
                    style={{ marginTop: "10px", marginBottom: "5px" }}
                    className="custom-input"
                  >
                    <span className="required">*</span>
                    Titre de l'email
                  </div>
                  <Input
                    value={this.state.emailTitle}
                    onChange={(e) =>
                      this.setState({ emailTitle: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="form-group">
                <div>
                  <div className="custom-input">
                    <span className="required">*</span>
                    Message à envoyer
                    <div style={{ color: "#a8a8a8", fontSize: "12px" }}>
                      Message à insérer dans le corp du mail
                    </div>
                  </div>
                  <Input.TextArea
                    rows={6}
                    name="message"
                    value={this.state.emailMessage}
                    onChange={(e) =>
                      this.setState({ emailMessage: e.target.value })
                    }
                  />
                </div>
              </div>
            </Modal>
          </div>
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./components/facturation.js